import * as yup from "yup";
import { useFormik } from "formik";
import React, { useState, useEffect } from "react";

import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import LoadingButton from "@mui/lab/LoadingButton";
import { Box, OutlinedInput } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";

import Title from "../../common/Title";

import useAlert from "../../../hooks/useAlert";
import useAxios from "../../../hooks/useAxios";
import { CLIENTS } from "../../../constants/value";
import { __getCredential, __updateCredential } from "../../../api/sim";

const FIELDS = [
  { name: "username", label: "Username" },
  { name: "password", label: "Token / Password" },
  { name: "api_key", label: "PIN" },
  { name: "secret_key", label: "Clec ID" },
  { name: "organization", label: "MVNO ID" },
];

const PWGCredentialForm = () => {
  const [credential, setCredential] = useState(null);
  const [formData, setFormData] = useState(null);

  const { setAlertMessage } = useAlert();
  const [response, call, loading] = useAxios({
    ...__getCredential(CLIENTS.pwg),
  });
  const [updateResponse, updateCall, updateLoading] = useAxios({
    ...__updateCredential(CLIENTS.pwg),
  });
  useEffect(() => {
    call();
  }, []);

  useEffect(() => {
    if (formData) {
      updateCall({
        data: formData,
      });
    }
  }, [formData]);

  useEffect(() => {
    if (!updateResponse) return;
    if (updateResponse.status) {
      setCredential(updateResponse.data);
      setAlertMessage({ type: "success", message: "Update successful" });
    }
  }, [updateResponse]);

  useEffect(() => {
    if (!response) return;
    if (response.status) {
      setCredential(response.data);
      formik.setValues(
        FIELDS.reduce((acc, field) => {
          acc[field.name] = response.data[field.name];
          return acc;
        }, {})
      );
    }
  }, [response]);

  const initialData = FIELDS.reduce((acc, field) => {
    acc[field.name] = "";
    return acc;
  }, {});

  const validationSchema = yup.object(
    FIELDS.reduce((acc, field) => {
      acc[field.name] = yup.string(field.name);
      return acc;
    }, {})
  );

  const formik = useFormik({
    initialValues: { ...initialData },
    onSubmit: (values) => {
      const requestData = Object.keys(values).reduce((obj, key) => {
        obj[key] = values[key] || null;
        return obj;
      }, {});

      setFormData(requestData);
    },
    validationSchema: validationSchema,
    validateOnChange: true,
  });

  if (loading || updateLoading) {
    return <Title content="Please wait..." variant="subtitle2" gutterBottom />;
  }

  return (
    <>
      <Box
        sx={{ width: "100%" }}
        display="flex"
        alignItems="center"
        flexDirection="column"
      >
        <Title
          variant="h5"
          content="PWG Credentials"
          sx={{ mb: 3 }}
          gutterBottom
        />
        <Grid
          sx={{ flexGrow: 1, width: "100%" }}
          container
          spacing={2}
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          {FIELDS.map((field) => (
            <Grid item xs sx={{ minWidth: 400 }} key={field.name}>
              <FormControl
                error={
                  formik.touched[field.name] &&
                  Boolean(formik.errors[field.name])
                    ? true
                    : false
                }
                sx={{ width: "100%" }}
              >
                <InputLabel htmlFor={field.name}>{field.label}</InputLabel>
                <OutlinedInput
                  name={field.name}
                  label={field.label}
                  id={field.name}
                  value={formik.values[field.name]}
                  onChange={formik.handleChange}
                />
                {formik.touched[field.name] &&
                Boolean(formik.errors[field.name]) ? (
                  <FormHelperText id={`${field.name}-error-text`}>
                    {formik.errors[field.name]}
                  </FormHelperText>
                ) : (
                  ""
                )}
              </FormControl>
            </Grid>
          ))}

          <Grid
            container
            sx={{ mt: 3 }}
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Grid item>
              <LoadingButton
                style={{ marginRight: "5px" }}
                disabled={loading || updateLoading}
                onClick={() =>
                  !loading && !updateLoading && formik.submitForm()
                }
                size="large"
                loading={loading}
                variant="contained"
              >
                {"Update"}
              </LoadingButton>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default PWGCredentialForm;
